import "babel-polyfill";

import Vue from "vue";
import Vuex from "vuex";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const firebaseApp = firebase.initializeApp(require("@/json/firebase.json"));
export const db = firebaseApp.firestore();

import user from "./modules/user";

Vue.use(Vuex);

const state = {
  db: db,
  firebase: firebase,
  currentUser: firebase.auth().currentUser,
  storage: firebase.storage(),
  columnsConnected: require("@/json/columns.connected.json")
};

export default new Vuex.Store({
  state,
  modules: {
    user
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js